import { render, staticRenderFns } from "./WebhookQuicktable.vue?vue&type=template&id=f0be9424&"
import script from "./WebhookQuicktable.vue?vue&type=script&lang=js&"
export * from "./WebhookQuicktable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports